export interface ImageAnnotationActionStateArgs {
  hasSourcePort: boolean
  hasCanvas: boolean
  hasProject: boolean
  hasImagePath: boolean
  hasImageUrl: boolean
}

export interface ImageAnnotationActionState {
  visible: boolean
  disabled: boolean
}

/**
 * Keep schema eligibility separate from asset readiness. Every account sees
 * the action on a schema-eligible node; an empty node simply cannot open the
 * editor yet.
 */
export function resolveImageAnnotationActionState({
  hasSourcePort,
  hasCanvas,
  hasProject,
  hasImagePath,
  hasImageUrl,
}: ImageAnnotationActionStateArgs): ImageAnnotationActionState {
  return {
    visible: hasSourcePort && hasCanvas && hasProject,
    disabled: !hasImagePath || !hasImageUrl,
  }
}
